import { FC, memo, useEffect, useState } from "react";

import ReportTable from "@/components/reportTable/ReportTable";
import { IExaminationDataValue } from "@/models/ExaminationDataValue";
import { ExaminationDataApi } from "@/api";

interface ReportTableProps {
  examId: number;
  period: 10 | 60;
}

const ChosenReportTable: FC<ReportTableProps> = ({ period, examId }) => {
  const [reports, setReports] = useState<IExaminationDataValue[]>([]);

  useEffect(() => {
    if (examId) {
      (async () => {
        try {
          setReports(
            await ExaminationDataApi.getExaminationData(examId, period)
          );
        } catch (e) {
          console.log(e);
        }
      })();
    }
  }, [examId, period]);

  return <ReportTable data={reports} />;
};

export default memo(ChosenReportTable);
